import { Icon, IconButton, InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";

export default function PasswordInput(props: {
    label: string;
    value: string;
    onChange: (string) => void;
}) {
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChange(event.target.value);
    };

    return (
        <TextField
            onChange={handlePasswordChange}
            autoComplete="current-password"
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? (
                                <Icon>visibility_off</Icon>
                            ) : (
                                <Icon>visibility</Icon>
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            label={props.label}
            type={showPassword ? "text" : "password"}
        />
    );
}
